import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RadioComponent } from '../../../../shared/components/form-controls/radio/radio.component';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

export interface DownloadOptions {
  format: 'csv' | 'xlsx';
  scope: 'all' | 'filtered';
}

@Component({
  selector: 'app-download-dialog',
  standalone: true,
  imports: [FormsModule, TranslatePipe, RadioComponent],
  templateUrl: './download-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './download-dialog.component.css',
})
export class DownloadDialogComponent {
  // Inputs - using input() instead of signal for component inputs
  filteredCount = input<number>(0);
  totalCount = input<number>(0);

  // Events
  download = output<DownloadOptions>();
  cancel = output<void>();

  // Internal state
  selectedFormat: 'csv' | 'xlsx' = 'xlsx';
  selectedScope: 'all' | 'filtered' = 'all';

  onDownload(): void {
    this.download.emit({
      format: this.selectedFormat,
      scope: this.selectedScope,
    });
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
